import React, { forwardRef } from "react";
import { func, string } from "prop-types";

import actionElements from "../../../../constants/actionElements";
import TextAction, { textActionTypography } from "../../../../text-action";
import * as S from "./styled";

const SuggestedEmail = forwardRef(
  ({ className, onClick, suggestedEmail, ...passThroughProps }, ref) => (
    <span ref={ref} className={className} {...passThroughProps}>
      <S.Text>
        Did you mean{" "}
        <TextAction
          element={actionElements.button}
          onClick={onClick}
          type="button"
          typography={textActionTypography.BODY}
          underlined={false}
        >
          {suggestedEmail}
        </TextAction>
        ?
      </S.Text>
    </span>
  )
);

SuggestedEmail.propTypes = {
  className: string,
  onClick: func.isRequired,
  suggestedEmail: string.isRequired
};

SuggestedEmail.defaultProps = {
  className: ""
};

export default SuggestedEmail;
